import ReactOnRails from 'react-on-rails';
import SeoCitySubType from '../../bundles/SeoCitySubType/components/SeoCitySubType.client.jsx';

ReactOnRails.register({SeoCitySubType});
